import React from 'react'
import DialogContent from '@mui/material/DialogContent';
import { createDraggablePaperComponent } from '../../dialog/DraggablePaper';
import MasProductListContainer from '../../../../containers/common/form/modal/MasProductListContainer'
import BootstrapDialog, { BootstrapDialogTitle } from '../../dialog/BootstrapDialog'


const PaperComponent = createDraggablePaperComponent('draggable-product-dialog');

const MasProductModal = ({ title, handleClose, open, selectedProduct }) => {
    return (
        <BootstrapDialog
            open={open}
            onClose={handleClose}
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-product-dialog"
            fullWidth={true}
            maxWidth="md"
        >
            <BootstrapDialogTitle style={{ cursor: 'move' }} id="draggable-product-dialog" onClose={handleClose}>
                {title}
            </BootstrapDialogTitle>
            <DialogContent dividers>
                <MasProductListContainer selectedProduct={selectedProduct} handleClose={handleClose} />
            </DialogContent>
        </BootstrapDialog>
    )
}

export default MasProductModal